import { Alert } from 'antd'

const CrmInputsError = ({ errorList }) => {
    const getErrorList = () => {
        return(
            <>
                <p>Please fix following error(s):</p>
                {errorList.map(error => <p>{error}</p>)}
            </>
        ) 
    }

    return (
        <div className='crm-input-error'>
            <Alert message={getErrorList()} type="error" showIcon />
        </div>
    )
}

export default CrmInputsError